export default __webpack_public_path__ + "resources/icons/d332-d6d5.png";